declare namespace $ {

	type $mol_string__value_bog_calculator_app_1 = $mol_type_enforce<
		ReturnType< $bog_calculator_app['display_value'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_button_minor__title_bog_calculator_app_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__title_bog_calculator_app_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__title_bog_calculator_app_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__title_bog_calculator_app_5 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__title_bog_calculator_app_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__title_bog_calculator_app_7 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__title_bog_calculator_app_8 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__title_bog_calculator_app_9 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__title_bog_calculator_app_10 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__title_bog_calculator_app_11 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__title_bog_calculator_app_12 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__title_bog_calculator_app_13 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__title_bog_calculator_app_14 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__title_bog_calculator_app_15 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__title_bog_calculator_app_16 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__title_bog_calculator_app_17 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__title_bog_calculator_app_18 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__title_bog_calculator_app_19 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__title_bog_calculator_app_20 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_view__style_bog_calculator_app_21 = $mol_type_enforce<
		({ 
			'display': string,
			'gridTemplateColumns': string,
			'gap': string,
		}) 
		,
		ReturnType< $mol_view['style'] >
	>
	type $mol_view__sub_bog_calculator_app_22 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_calculator_app_23 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $bog_calculator_app extends $mol_page {
		Theme( ): $mol_theme_auto
		Lights( ): $mol_lights_toggle
		display_value( next?: string ): string
		Display( ): $mol_string
		Button_AC( ): $mol_button_minor
		Button_plus_minus( ): $mol_button_minor
		Button_percent( ): $mol_button_minor
		Button_divide( ): $mol_button_minor
		Button_7( ): $mol_button_minor
		Button_8( ): $mol_button_minor
		Button_9( ): $mol_button_minor
		Button_multiply( ): $mol_button_minor
		Button_4( ): $mol_button_minor
		Button_5( ): $mol_button_minor
		Button_6( ): $mol_button_minor
		Button_minus( ): $mol_button_minor
		Button_1( ): $mol_button_minor
		Button_2( ): $mol_button_minor
		Button_3( ): $mol_button_minor
		Button_plus( ): $mol_button_minor
		Button_0( ): $mol_button_minor
		Button_dot( ): $mol_button_minor
		Button_equals( ): $mol_button_minor
		Buttons( ): $mol_view
		Calculator( ): $mol_view
		title( ): string
		plugins( ): readonly(any)[]
		tools( ): readonly(any)[]
		body( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=app.view.tree.d.ts.map